module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-sidebar-wrapper"
  }, [_c('div', {
    staticClass: "modal-sidebar"
  }, [_c('div', {
    staticClass: "modal-sidebar-header"
  }, [_vm._t("preview-link"), _vm._v(" "), _vm._t("editor-title", [_c('p', [_vm._v(_vm._s(_vm.$t('module_editor.module_editor')))])]), _vm._v(" "), _c('span', {
    staticClass: "close-modal",
    attrs: {
      "title": "Close Module"
    },
    on: {
      "click": function($event) {
        _vm.$emit('closeModuleSidebar')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-sidebar-body"
  }, [(_vm.parentSidebarTab === 'content') ? _c('div', [_c('p', {
    staticClass: "modal-sidebar-header-text"
  }, [_vm._v(_vm._s(_vm.$t('module_editor.content')))]), _vm._v(" "), _c('ul', {
    staticClass: "content-blocks"
  }, [_c('draggable', {
    attrs: {
      "list": _vm.partsList,
      "options": {
        group: {
          name: 'omega',
          pull: 'clone',
          put: false
        },
        sort: false
      },
      "clone": _vm.cloneNewPart
    }
  }, _vm._l((_vm.partsList), function(part) {
    return _c('li', {
      key: part.id,
      staticClass: "part-list-button",
      on: {
        "click": function($event) {
          _vm.addPartToDocument(part)
        }
      }
    }, [_c('span', [_c('i', {
      staticClass: "icon",
      class: part.icon
    }), _vm._v("\n                " + _vm._s(part.title) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "document-drag-zone"
    }, [_vm._v(_vm._s(_vm.$t('module_editor.drop_content_here')))])])
  }))], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-sidebar-footer"
  }, [_c('span', {
    staticClass: "actions"
  }, [_c('a', {
    staticClass: "button is-primary is-large",
    on: {
      "click": function($event) {
        _vm.$emit('save')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('module_editor.save_changes')))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a377f97","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/partials/module-editor-sidebar.vue
// module id = 512
// module chunks = 0